import { CheckSquare, FileText, ThumbsUp } from "lucide-react";

export default function VoIPSimpleStepsDark() {
    const steps = [
        {
            icon: CheckSquare,
            number: "1",
            title: "Tell Us What Your Business Needs",
            description: "Fill out a short form so we understand your team size, call volume and setup."
        },
        {
            icon: FileText,
            number: "2",
            title: "Receive Custom VoIP Quotes (FREE)",
            description: "We compare multiple VoIP Australia solutions and match you with the best fit."
        },
        {
            icon: ThumbsUp,
            number: "3",
            title: "Choose the Best Deal & Start Saving",
            description: "Review your options, pick what suits your business, and enjoy lower monthly costs."
        }
    ];

    return (
        <section className="py-20 lg:pb-24 lg:pt-16 relative overflow-hidden">
            <div className="container">
                {/* Header */}
                <div className="text-center mb-16">
                    <span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
                        How It Works
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        Three simple steps to get started
                    </h2>
                </div>

                {/* Steps Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {steps.map((step, index) => {
                        const Icon = step.icon;
                        return (
                            <div key={index} className="group">
                                <div className="bg-gradient-to-br from-purple-600/5 to-blue-600/5 rounded-2xl p-8 border border-purple-500/20 hover:border-purple-500/50 transition-all duration-300 h-full flex flex-col">
                                    {/* Icon */}
                                    <div className="w-16 h-16 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mb-6">
                                        <Icon className="w-8 h-8 text-white" strokeWidth={1.5} />
                                    </div>

                                    {/* Title */}
                                    <h3 className="text-xl font-bold text-white mb-4">
                                        Step {step.number}: {step.title}
                                    </h3>

                                    {/* Description */}
                                    <p className="text-gray-300 text-base leading-relaxed">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}